import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, Grid, Paper, Stack, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

export default function PriceBreakdown2({ prix_net_vendeur, warning, prix_public, bk_fees, settings }) {
    console.log("render PriceBreakdown2", prix_public, prix_net_vendeur, bk_fees, settings)
    if (!settings) return false;
    const [state, setState] = useState({});

    // const num_price = parseInt(price)
    var pv;
    var comm;
    var pnv;
    if (prix_public) {
        comm = bk_fees;
        pv = prix_public;
        pnv = pv - comm

    } else {
        pnv = prix_net_vendeur;
        //  pv = Math.floor(Math.min((prix_net_vendeur * 1.0) + 4800, prix_net_vendeur * (102) / 100));
        if (settings.w) {

            comm = Math.floor(Math.min(prix_net_vendeur, settings.y) * settings.x / 100);

            // pv = Math.floor(Math.min((prix_net_vendeur * 1.0) + settings.y, prix_net_vendeur * (100 + settings.x) / 100));
        }
        else {
            // pv = Math.floor(prix_net_vendeur * (100 + settings.x) / 100);
            comm = Math.floor(prix_net_vendeur * settings.x / 100);
        }
        console.log("...", comm, pv, prix_net_vendeur);
        pv = comm + parseInt(prix_net_vendeur)
        //pv = Math.floor(Math.min((prix_net_vendeur * 1.0) + settings.y, prix_net_vendeur * (100 + settings.x) / 100));

    }

    console.log("state", state, pv, "hon", comm);
    return (
        <Stack spacing={1}>
            <Box display={"flex"} justifyContent="space-between" alignItems={"center"}>
                <Box>
                    <Typography variant="body1">Prix de vente (honoraires Bkeys inclus)</Typography>
                </Box>
                <Box>
                    {pv ? <Typography variant="body1">{pv.toString().match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g).join(" ")}&nbsp;€</Typography> : ""}
                </Box>
            </Box>

            {warning && <Box display={"flex"} justifyContent="flex-start" alignItems={"center"} style="margin-bottom: 5px;">
                <Box>
                    <WarningIcon color="primary" />
                </Box>
                <Box p={1}>
                    <Typography variant="body1">Prix affiché sur l'annonce</Typography>
                </Box>
            </Box>}

            <Box display={"flex"} justifyContent="space-between" alignItems={"center"}>
                <Box>
                    <Typography variant="body1">Honoraires Bkeys</Typography>
                </Box>
                <Box>
                    {comm ? comm.toString().match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g).join(' ') + " €" : ""}
                </Box>
            </Box>
            <Box display={"flex"} justifyContent="space-between" alignItems={"center"}>
                <Box>
                    <Typography variant="body1">Dont honoraires ambassadeur</Typography>
                </Box>
                <Box>
                    {/* <b> {comm ? Math.floor(comm / 2 / 1.2).toString().match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g).join(' ') + " €" : ""}</b> */}
                    <b> {comm ? Math.floor(comm * (settings.z) / 1.2).toString().match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g).join(' ') + " €" : ""}</b>
                </Box>
            </Box>
        </Stack>)
}